<template>
  <!-- 头部 -->
  <div class="navbar">
    <ul class="menu-box">
      <li v-for="(navbarItem, index) in navbarList"
          :key="navbarItem.meta.id"
          class="menu-item dropdown"
          :class="{active: activeIndex === index, long: navbarItem.meta.title == '重庆市制造业高质量发展服务矩阵'}">
          
        <div class="active-bg"></div>
        <router-link class="top-menu" :to="navbarItem.url" @click.native="jump(index)">{{ navbarItem.meta.title }}</router-link>
<!--        <a class="top-menu" :href="javascript:void(0)" @click="jump(index)">{{ navbarItem.meta.title }}</a>-->
<!--        <router-link class="top-menu" v-if="navbarItem.children.length === 0" :to="navbarItem.url" @click.native="jump(index)">{{ navbarItem.meta.title }}</router-link>
        <a class="top-menu" v-else href="javascript:void(0)">{{ navbarItem.meta.title }}</a>-->
<!--        <ul v-if="navbarItem.children.length > 0" class="dropdown-content">
          <li v-for="(childrenItem, indexSub) in navbarItem.children" :key="childrenItem.meta.id" class="sub-menu">
            <router-link class="child-menu" :to="childrenItem.url"  @click.native="jump(index, true)">{{childrenItem.meta.title}}</router-link>
          </li>
        </ul>-->
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: "Navbar",
  props: {

  },
  data() {
    return {
      navbarList: [],
      activeIndex: 0
    }
  },
  computed: {

  },
  watch: {
    /*'$store.state.navbar.navbarList': {
      immediate: true,
      handler: function(navbarList) {
        this.navbarList = navbarList
        this.$router.onReady(() => {
          this.getOnloadActiveMenu()
        });
      }
    }*/
    $route(to,from) {
      this.$router.onReady(() => {
        this.navbarList = this.$store.state.navbar.navbarList
        this.getOnloadActiveMenu()
      });
    }
  },
  methods: {
    jump(targetIndex) {
      this.$router.onReady(() => {
        this.activeIndex = targetIndex
      });
    },
    getOnloadActiveMenu() {
      let navbarList = this.navbarList
      let currentPath = this.$route.path.split('?')[0]
      console.log('currentPath', currentPath)
      if(currentPath === '/search' || currentPath === '/radio' || currentPath === '/details_radio' || currentPath === '/radio_list') {
        this.activeIndex = -1
        return
      }
      if(currentPath === '/details') {
        let channelId = this.$route.query.channelId
        if(channelId === undefined || isNaN(channelId)) {
          return
        }
        channelId = parseInt(channelId)
        for(let i=0; i<navbarList.length; i++) {
          if(navbarList[i].meta.id === channelId) {
            this.activeIndex = i
            break
          } else if(navbarList[i].children.length > 0) {
            for(let subNav of navbarList[i].children) {
              if(subNav.id === channelId) {
                this.activeIndex = i
                break
              }
            }
          }
        }
        return
      }
      if(currentPath === '/') {
        this.activeIndex = 0
      } else {
        for(let i=0; i<navbarList.length; i++) {
          if(navbarList[i].url === currentPath) {
            this.activeIndex = i
            break
          }
          if(navbarList[i].children.length > 0) {
            let children = navbarList[i].children
            for(let j=0; j<children.length; j++) {
              if(children[j].url === currentPath) {
                this.activeIndex = i
              }
            }
          }
        }
      }
    },
    getActiveMenu() {
      this.$router.onReady(() => {
        let navbarList = this.navbarList
        let currentPath = this.$route.path
        if(currentPath === '/') {
          this.activeIndex = 0
        } else {
          for(let i=0; i<navbarList.length; i++) {
            if(navbarList[i].url === currentPath) {
              this.activeIndex = i
              break
            }
            if(navbarList[i].children.length > 0) {
              let children = navbarList[i]
              for(let j=0; j<children.length; j++) {
                if(children[j].url === currentPath) {
                  this.activeIndex = i
                }
              }
            }
          }
        }
      })
    }
  },
  activated() {
    /*this.$router.onReady(() => {
      this.navbarList = this.$store.state.navbar.navbarList
      this.getOnloadActiveMenu()
    })*/
  },
  mounted() {
    /*this.$router.onReady(() => {
      this.navbarList = this.$store.state.navbar.navbarList
      this.getOnloadActiveMenu()
    })*/
  }
}
</script>

<style scoped lang="less">
  .navbar {
    position: relative;
    z-index: 9;
    overflow: visible;
    width:100%;
    height:50px;
    min-height:50px;
    margin-top: -1px;
    display:flex;
    flex-direction:row;
    justify-content: center;
    flex-shrink:0;
    flex-wrap:nowrap;
    background-color: @baseDarkBlue;
    box-sizing:border-box;
    .menu-box {
      position: relative;
      z-index: 99;
      width: @baseContentWidth;
      height: 100%;
      margin: 0 auto;
      overflow: visible;
      .dropdown {
        position: relative;
        z-index: 1;
        overflow: visible;
        width: 144px;
        height: 100%;
        box-sizing: border-box;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        float: left;
        &.long {
          width: 286px;
          a {
            width: 286px;
          }
        }
        .active-bg {
          position: absolute;
          z-index: 9;
          left: 0;
          top: -8px;
          width: 100%;
          height: 60px;
          background-color: transparent;
          transition: backgroundColor linear 0.2s;
        }
        &.active {
          .active-bg {
            background-color: #1195E0;
          }
          a {
            color: #FFF;
            font-weight: 500;
            &:hover {
              color: #FFF !important;
            }
          }
        }
        a {
          position: relative;
          z-index: 99;
          display: block;
          width: 144px;
          height: 100%;
          text-decoration: none;
          font-size: 18px;
          color: #FFF;
          &:hover {
            color: #FFF !important;
          }
        }
        &:hover {
          background-color: @baseDarkBlue;
          a.top-menu {
            color: #FFF !important;
          }
        }
        /*.dropdown-content {
          display: none;
          position: absolute;
          z-index: 99999;
          min-width: 196px;
          box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
          background-color: rgba(229, 229, 229, 1);
          .sub-menu {
            width: 100%;
            height: 50px;
            box-sizing: border-box;
            border-bottom: 1px solid rgba(16,79,174,0.1);
            &:hover {
              background-color: #104fae;
              a.child-menu {
                color: #FFF !important;
              }
            }
            a {
              display: block;
              width: 196px;
              height: 100%;
              color: #333;
              font-weight: bold;
            }
          }
        }*/
      }
    }
  }

</style>
